import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Select } from "common/elements/Select/Select";
import { btnDelay, usePlaySound, useScale } from "common/utils";
import parentI18n from "features/parent/i18n";
import { BackBtn } from "./BackBtn";
import { useAuthLocale } from "./useAuthLocale";
import { EmailLoginForm } from "./EmailLoginForm";

export const EmailLoginScreen = () => {
  const { currentLocale, changeLocale, localeOptions, localeLabels } = useAuthLocale();
  const navigate = useNavigate();
  const playSound = usePlaySound();
  const { width, height, scale } = useScale();
  const [localeOpen, setLocaleOpen] = useState(false);
  const langBtnRef = useRef<HTMLButtonElement>(null);

  const handleToggleLocale = () => {
    btnDelay(() => {
      playSound();
      setLocaleOpen(!localeOpen);
    });
  };

  const handleCloseLocale = () => {
    setLocaleOpen(false);
  };

  const handleChangeLocale = (locale: string) => {
    changeLocale(locale);
  };

  const handleForgotPassword = () => {
    navigate("/auth/password-reset");
  };

  return (
    <div className="flex-col-el w-full h-full bg-gray2-30">
      {/* ヘッダー */}
      <div style={{ height: 90 * scale }} className="flex-col-el flex-center">
        <header
          style={{ transform: `scale(${scale})`, width: width / scale }}
          className="flex-row-el h-[90px] items-center px-6 py-4 border-b border-outline bg-white"
        >
          <BackBtn />
          <p className="ml-6 text-[27px] text-textcolor-black">
            {parentI18n.t("MSG_SIGN_IN_WITH_MAIL")}
          </p>
          {/* 言語選択ボタン - 右端に配置 */}
          <div className="ml-auto flex-row-el items-center gap-3">
            <span className="text-[20px] text-textcolor-black w-[140px] text-right">
              {parentI18n.t("MSG_PARENT_PAGE_DISPLAY_LANGUAGE")}
            </span>
            <button
              ref={langBtnRef}
              onClick={handleToggleLocale}
              className="border-0 bg-green-100 flex-row-el items-center gap-2 px-4 py-2 rounded-full cursor-pointer transition-all w-[150px]"
            >
              <span className="material-symbols-outlined text-white !text-[20px]">language</span>
              <span className="text-body text-white text-[16px] flex-1 text-center">
                {localeLabels[currentLocale] || localeLabels["ja_kanji"]}
              </span>
              <span className="material-symbols-outlined text-white !text-[16px]">expand_more</span>
            </button>
          </div>
          <Select
            anchorRef={langBtnRef}
            open={localeOpen}
            onClose={handleCloseLocale}
            value={currentLocale}
            onChange={handleChangeLocale}
            options={[...localeOptions]}
          />
        </header>
      </div>

      {/* メインコンテンツ */}
      <div
        style={{ height: height - 90 * scale }}
        className="flex-col-el items-center justify-start w-full bg-white/40"
      >
        <main
          style={{
            width: width / scale,
            height: (height - 90 * scale) / scale,
            transform: `scale(${scale})`,
          }}
          className="flex-col-el flex-center shrink-0 p-6 origin-top overflow-y-auto"
        >
          <div className="bg-white rounded-[16px] p-8 max-w-md w-full">
            <EmailLoginForm
              onSuccess={() => navigate("/")}
              onForgotPassword={handleForgotPassword}
            />
          </div>
        </main>
      </div>
    </div>
  );
};
